const BarraApp = () => null;

export default BarraApp;
